import React from 'react';
import { BsDot } from 'react-icons/bs';

const SoilWaterTagLine = () => {
  return (
    <>
      <div className="mb-5 mt-10 flex items-center justify-center gap-2 text-base tracking-wide text-secondary-dark">
        SOIL <BsDot className="text-2xl" /> WATER <BsDot className="text-2xl" />{' '}
        PLANT <BsDot className="text-2xl" />
        ANIMAL
      </div>
    </>
  );
};

export default SoilWaterTagLine;
